import apiService from "../services/apiService";
import { useQuery } from "react-query";
import {
  StoreLocation,
  StoreLocationMarkerApiResponse,
  StoreLocationsResponse
} from "../types/StoreLocation";
import { useUser } from "../functional-components/UserContext";

export function useStoreLocations(lang: string): StoreLocationsResponse {
  const { admin } = useUser();
  const { data } = useQuery(["storeLocations", lang, admin], async () =>
    apiService.getStoreLocations(lang)
  );
  return {
    ...data,
    locations: data.locations.map((loc: StoreLocationMarkerApiResponse) => ({
      ...loc,
      lat: parseFloat(loc.lat),
      lng: parseFloat(loc.lng)
    }))
  };
}

export function useStoreLocation(gid: number, row: number): StoreLocation {
  const { data } = useQuery(["storeLocation", gid, row], async () =>
    apiService.getStoreLocation(gid, row)
  );
  return data;
}
